/**
 * @description 还原被裁剪的图片地址
 * @param url
 * @returns
 */
export const _originDtImageUrl = (url: string): string => {
  const { pathname } = new URL(url);
  const host = 'https://c-ssl.dtstatic.com';
  url = host + pathname;
  return url.replace(/\?.*$/, '').replace(/(?:\.thumb\.\w+|\.[a-z]+!\w+)(\.[a-z_]+)$/gi, '$1');
};
